import debug from 'debug'

// Only enable in development
if (!ENV.isProduction) {
    debug.enable('zap:*')
}

export const syncLog = debug('zap:sync')
export const debugLog = debug('zap:debug')
export const queryLog = debug('zap:query')
export const sendLog = debug('zap:send')
export const localStorageLog = debug('zap:localStorage')
export const connectionLog = debug('zap:connection')
